import { colors, fonts, fontSizes } from 'theme'
import css from 'styled-jsx/css'

export default css`
  .card {
    display: flex;
    flex-direction: column;
    color: ${colors.text};
    padding: 1rem;
  }

  .info .avatar {
    width: 4.5rem;
    height: 4.5rem;
    overflow: hidden;
    border-radius: 50%;
  }
  .info .avatar img {
    object-fit: cover;
    width: 100%;
    min-height: 100%;
  }

  .info .avatar :global(.broker-card-image) {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  .info {
    display: flex;
    margin-bottom: 1rem;
  }

  .details {
    display: flex;
    flex-direction: column;
    margin-left: 1rem;
  }

  .name {
    color:${colors.text};
    font-size: ${fontSizes.h5};
  }

  .role {
    font-size: ${fontSizes.body};
    margin: 0;
    color: ${colors.primary}
  }
  @media screen and (max-width: 992px) {
    .card {
      min-height: 9rem;
    }
  }

  .nexsite1-broker-card.card {
    min-height: auto;
    margin: 1rem 0;
    padding: 0;
    background: ${colors.white};
  }
`
